// libs
import { styled } from '@nykaa/ui-components';

// global components
import Button from '@nykaa/ui-components/Button';
import { BREAKPOINTS } from 'shared/styles/base';

export const Container = styled.div`
  width: 100%;
  position: relative;
  @media screen and (min-width: ${BREAKPOINTS.DESKTOP}px) {
    padding: ${({ theme }) =>
      `${theme.spacing.spacing0} ${theme.spacing.spacing40} ${theme.spacing.spacing0} ${theme.spacing.spacing40}`};
    margin-bottom: ${({ theme }) => theme.spacing.spacing50};
`;

export const ActionButton = styled(Button)`
  border-radius: ${({ theme }) => theme.borders.radius10};
`;
